import gql from 'graphql-tag';

const PREVIEW_ADVANCE_POLICY_RULES = gql`
  mutation previewAdvancePolicyRules($classId: ID) {
    previewAdvancePolicyRules(classId: $classId)
  }
`;

const PUBLISH_ADVANCE_POLICY_RULES = gql`
  mutation publishAdvancePolicyRules($classId: ID) {
    publishAdvancePolicyRules(classId: $classId)
  }
`;

const ORGANIZE_ADVANCE_POLICY_RULES = gql`
  mutation organizeAdvancePolicyRules(
    $input: [OrganizeAdvancePolicyRuleInput]!
  ) {
    organizeAdvancePolicyRules(input: $input)
  }
`;

const CREATE_ADVANCE_POLICY_RULE = gql`
  mutation CreateAdvancePolicyRule($input: AddAdvancePolicyRuleInput!) {
    createAdvancePolicyRule(input: $input) {
      id
      name
      description
      ruleCondition
      ruleOrder
      assetClass {
        classId
        name
      }
      policyCategory {
        policyCategoryId
        name
      }
      ruleVersion
      createdTime
      updatedTime
    }
  }
`;

const UPDATE_ADVANCE_POLICY_RULE = gql`
  mutation updateAdvancePolicyRule(
    $ruleId: ID!
    $input: UpdateAdvancePolicyRuleInput!
  ) {
    updateAdvancePolicyRule(ruleId: $ruleId, input: $input) {
      id
    }
  }
`;

const DELETE_ADVANCE_POLICY_RULE = gql`
  mutation deleteAdvancePolicyRule($ruleId: ID!) {
    deleteAdvancePolicyRule(ruleId: $ruleId)
  }
`;

const REMOVE_OVERRIDDEN_ASSETS = gql`
  mutation removeOverriddenAssets($assetIds: [ID!]) {
    removeOverriddenAssets(assetIds: $assetIds)
  }
`;

export {
  PREVIEW_ADVANCE_POLICY_RULES,
  PUBLISH_ADVANCE_POLICY_RULES,
  ORGANIZE_ADVANCE_POLICY_RULES,
  CREATE_ADVANCE_POLICY_RULE,
  DELETE_ADVANCE_POLICY_RULE,
  UPDATE_ADVANCE_POLICY_RULE,
  REMOVE_OVERRIDDEN_ASSETS
};
